import * as zod from 'zod';

export const PlannerType = zod.enum(['ompl', 'pilz']);

export type PlannerType = zod.infer<typeof PlannerType>;
